import React, { useRef } from "react";
import styled from "styled-components";
import { get } from "lodash";
import { Link, Route } from "react-router-dom";
import { Cabinet } from "@sonder/ui/source/styled/components/Cabinet";
import { LinkBaseStyles } from "@sonder/ui/source/styled/fragments/Link";
import { Content } from "@sonder/ui/source/styled/layouts/Content";
import { Layout as LayoutBase } from "@sonder/ui/source/styled/layouts/Layout";
import { useStore as useAuthStore } from "auth/store";
import { AppHeader } from "core/components/AppHeader";
import { EmptyContent } from "core/components/EmptyContent";
import { useLayout } from "core/components/LayoutProvider";
import { Sidebar } from "core/components/Sidebar";
import { TaskPanel } from "tasks/components/TaskPanel";
import { NotificationCenterDrawer } from "users/components/NotificationCenterDrawer";

const StyledLink = styled(Link)`
  ${LinkBaseStyles}
`;
interface LayoutProps {
  children: React.ReactNode;
  pageTitle: string;
  pageSubheader: React.ReactNode;
}

export const Layout = ({
  children,
  pageTitle,
  pageSubheader: PageSubheader,
}: LayoutProps) => {
  const sidebarRef = useRef<HTMLElement>(null);
  const { state: authState } = useAuthStore();
  const tomCityId = get(authState, "user.cityId", null);
  const authStatus = authState.status;
  const { sidepanel } = useLayout();
  const userHasNoCityAffiliation =
    authStatus === "logged-in" && tomCityId === null;
  return (
    <LayoutBase sidepanel={sidepanel}>
      <Sidebar ref={sidebarRef} />
      <AppHeader title={pageTitle}>
        {!userHasNoCityAffiliation && PageSubheader}
      </AppHeader>
      <Route
        path="/tasks/:taskId"
        render={({ history }) => (
          <TaskPanel onClose={() => history.push("/tasks")} />
        )}
      />
      <Route
        path="/schedule/:taskId"
        render={({ history }) => (
          <TaskPanel onClose={() => history.push("/schedule")} />
        )}
      />
      <Content>
        {!userHasNoCityAffiliation ? (
          children
        ) : (
          <EmptyContent>
            <p>
              Your account is not currently associated with a Sonder city team.
              <br />
              Please ask your <b>Manager</b> to add you on the Dispatch
              Dashboard <StyledLink to="/teams">Teams</StyledLink> Page.
            </p>
          </EmptyContent>
        )}
      </Content>
      <Cabinet offsetNode={sidebarRef}>
        <>
          <NotificationCenterDrawer />
        </>
      </Cabinet>
    </LayoutBase>
  );
};
